import { createAction } from 'redux-actions';
import { bindRoutineToReduxForm, createRoutine } from 'redux-saga-routines';
import {
  UPLOAD_VIDEO,
  SEARCH_VIDEOS_TERM,
  SEARCH_VIDEOS_EQUIPMENT,
  SEARCH_VIDEOS_FOCUS_AREA,
  GET_VIDEOS,
  GET_FOCUS_AREAS,
  GET_EQUIPMENTS,
  SET_PAGINATION,
  SELECT_VIDEO,
  SELECT_VIDEO_CARD,
  EDIT_VIDEO,
  DELETE_VIDEO,
  SET_DATE_RANGE,
  CLEAR_FILTERS,
} from './types';

export const uploadVideo = createRoutine(UPLOAD_VIDEO);
export const selectVideo = createRoutine(SELECT_VIDEO);
export const editVideo = createRoutine(EDIT_VIDEO);
export const deleteVideo = createRoutine(DELETE_VIDEO);

export const getVideos = createRoutine(GET_VIDEOS);
export const getFocusAreas = createRoutine(GET_FOCUS_AREAS);
export const getEquipments = createRoutine(GET_EQUIPMENTS);

export const setPagination = createAction(SET_PAGINATION);
export const setSearchVideosTerm = createAction(SEARCH_VIDEOS_TERM);
export const setSearchVideosEquipment = createAction(SEARCH_VIDEOS_EQUIPMENT);
export const setSearchVideosFocusArea = createAction(SEARCH_VIDEOS_FOCUS_AREA);
export const selectVideoCard = createAction(SELECT_VIDEO_CARD);
export const setDateRange = createAction(SET_DATE_RANGE);
export const clearFilters = createAction(CLEAR_FILTERS);

export const bindedUploadVideo = bindRoutineToReduxForm(uploadVideo);
export const bindedSelectVideo = bindRoutineToReduxForm(selectVideo);
export const bindedEditVideo = bindRoutineToReduxForm(editVideo);
export const bindedDeleteVideo = bindRoutineToReduxForm(deleteVideo);
